/*jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import SocialButton from 'app/components/common/SocialButton.jsx';
import * as _ from 'underscore';
import Modal from 'app/components/common/Modal.jsx';
import { Breakpoint } from 'react-socks';

class RetweetPanel extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            displayType: 'expanded',
            showChangeMainModal: false,
            nextMainTweeter: this.props.mainTweeter
        };

        this.changeDisplayType = this.changeDisplayType.bind(this);
        this.changeMainTweeter = this.changeMainTweeter.bind(this);
        this.chooseMainTweeter = this.chooseMainTweeter.bind(this);
        this.updateMainTweeter = this.updateMainTweeter.bind(this);

    }

    changeDisplayType() {

        this.setState({
            displayType: (this.state.displayType === 'expanded') ? 'compact' : 'expanded'
        });

    }

    changeMainTweeter() {

        this.setState({
            showChangeMainModal: (this.state.showChangeMainModal) ? false : true
        });

    }

    chooseMainTweeter(e) {
        let id = e.currentTarget.dataset.id;

        if (id) {
            this.setState({
                nextMainTweeter: id
            });
        }

    }

    updateMainTweeter(e) {
        var constants = this.props.app.config.constants;


        this.props.socialClickHandler({
            currentTarget: {
                dataset: {
                    id: this.props.mainTweeter,
                    type: constants.POST_SVC_TWITTER
                }
            },
            target: {
                dataset: {
                    id: this.props.mainTweeter,
                    type: constants.POST_SVC_TWITTER
                }
            }
        });
        this.props.setMainTweeter(this.state.nextMainTweeter);

        this.setState({
            showChangeMainModal: false
        });

    }

    render() {
        let mainTweeter = this.props.findSocial(this.props.mainTweeter),
            mainTweeterElement = null,
            constants = this.props.app.config.constants,
            chevronIcon = (this.state.displayType === 'expanded') ? 'ion-chevron-down' : 'ion-chevron-up',
            wrapperClass = (this.props.context === 'modal' || this.props.context === 'list-add') ? 'twitter-tray-wrapper-in-modal' : 'twitter-tray-wrapper',
            trayClass = (this.state.displayType === 'expanded') ? '' : 'compact',
            retweeters = [],
            trayContent = null,
            changeMain = null,
            modalHeader = null,
            modalContent = null,
            modalFooter = null,
            twitters = _.filter(this.props.socials.list, (social) => {
                return social.psID == constants.POST_SVC_TWITTER;
            }),
            trayControl = null,
            compactAction = null,
            twitterTray = null;

        for (let i = 0; i < this.props.selectedSocials.length; ++i) {
            let social = this.props.findSocial(this.props.selectedSocials[i]);
            if (social) {
                if (social.psID == constants.POST_SVC_TWITTER && social.id != this.props.mainTweeter) {
                    retweeters.push(social);
                }
            }
        }

        if (mainTweeter) {
            mainTweeterElement = (
                <SocialButton
                    app={this.props.app}
                    social={mainTweeter}
                    context={this.props.context}
                    selected={true} />
            );
        } else {
            mainTweeterElement = (
                <SocialButton
                    app={this.props.app}
                    connect={true}
                    context={this.props.context} />
            );
        }

        if (this.props.context === 'input') {
            trayControl = (
                <div className="twitter-tray-control" onClick={this.changeDisplayType} role="button" aria-label="show controls">
                    <i className={"icon " + chevronIcon}></i>
                </div>
            );
        }

        if (this.state.showChangeMainModal) {
            modalHeader = (<span className="light-title">{"Choose a different origin Twitter account"}</span>);
            modalFooter = (
                <button onClick={this.updateMainTweeter} className="btn-primary active fixed">
                    save
                </button>
            );
            modalContent = (
                <div className="main-tweeter-chooser">
                    <ul className="detail-list clearfix">
                        {twitters.map((social) => {
                            let unselected = true;

                            if (social.id == this.state.nextMainTweeter) {
                                unselected = false;
                            }

                            return (
                                <li key={"maintwitter-" + social.id} className="list-item social" onClick={this.chooseMainTweeter} data-id={social.id} data-type={social.psID} role="button" aria-label="set main twitter account">
                                    <SocialButton
                                        app={this.props.app}
                                        unselected={unselected}
                                        social={social}
                                        context={this.props.context} />
                                </li>
                            );
                        })}
                    </ul>
                </div>
            );
            if (this.props.context === 'input') {
                changeMain = (
                    <Modal
                        headerContent={modalHeader}
                        content={modalContent}
                        footerContent={modalFooter}
                        lightBackground={true}
                        boxClass={'square'}
                        close={this.changeMainTweeter}/>
                );
            } else {
                changeMain = (
                    <div className="main-twitter-chooser in-modal">
                        <div className="main-twitter-chooser-title">
                            {modalHeader}
                        </div>
                        {modalContent}
                        <div className="main-twitter-chooser-footer">
                            <div className="cancel-main-twitter-chooser" onClick={this.changeMainTweeter} role="button" aria-label="cancel">cancel</div>{modalFooter}
                        </div>
                    </div>
                );
            }

        }

        if (this.state.displayType === 'expanded') {
            trayContent = (
                <div className="twitter-tray">
                    <div className="main-twitter">
                        <div className="main-twitter-label">
                            Origin
                        </div>
                        <div className="tweet-wrapper" onClick={this.changeMainTweeter} role="button" aria-label="change main twitter account">
                            {mainTweeterElement}
                        </div>
                    </div>
                    <div className="section-divider">
                        <i className="icon ion-android-arrow-forward"/>
                        <div className="retweet-count">
                            ({retweeters.length})
                        </div>
                    </div>
                    <div className="retweeters">
                        <div className="retweeter-label">
                            <Breakpoint desktop only>
                                {(this.props.twitterMaxedOut) ? (
                                    <span>You've selected the maximum number of retweet accounts.</span>
                                ) : (
                                    <span>Retweet your posts from the origin to these additional accounts:</span>
                                )}
                            </Breakpoint>
                            <Breakpoint mobile only>
                                {(this.props.twitterMaxedOut) ? (
                                    <span>You've selected the maximum number of retweet accounts.</span>
                                ) : (
                                    <span>Retweet your posts from the origin to these additional accounts ({retweeters.length}):</span>
                                )}
                            </Breakpoint>
                        </div>
                        <div className="retweeter-list">
                            <ul className="detail-list retweeter clearfix">
                                {retweeters.map((social) => {
                                    if (social.id !== this.props.mainTweeter) {
                                        return (
                                            <li key={"retweeter-" + social.id} className="list-item social" onClick={this.props.handleSocialClick} data-id={social.id} data-type={social.psID} role="button" aria-label={social.name}>
                                                <SocialButton
                                                    app={this.props.app}
                                                    social={social}
                                                    context={this.props.context}
                                                    selected={true}
                                                    retweet={true} />
                                            </li>
                                        );
                                    }
                                    return null;
                                })}
                            </ul>
                        </div>
                    </div>
                </div>
            );
        } else {
            compactAction = this.changeDisplayType;
            trayContent = (
                <div className="twitter-tray">
                    <div className="compact-display">
                        <div className="tweet-wrapper" onClick={this.changeMainTweeter} role="switch" aria-label="set main twitter account">
                            {mainTweeterElement}
                        </div>
                        <div className="divider">
                            <i className="icon ion-android-arrow-forward"/>
                        </div>
                        <div className="retweet-count">
                            <div className="count">{retweeters.length}</div>
                            <i className="ds-icon icon-retweet"></i>
                        </div>
                    </div>
                </div>
            );
        }

        if (((this.props.context === "modal" || this.props.context === "list-add") && this.state.showChangeMainModal === false) || this.props.context === "input") {
            twitterTray = (
                <div className={wrapperClass + " " + trayClass} onClick={compactAction} role="switch" aria-label="show controls">
                    {trayControl}
                    {trayContent}
                </div>
            );
        }

        return (
            <div>
                {changeMain}
                {twitterTray}
            </div>
        );

    }
}

RetweetPanel.propTypes = {
    selectedSocials: PropTypes.array,
    mainTweeter: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    context: PropTypes.string,
    reselectMain: PropTypes.func,
    socialClickHandler: PropTypes.func,
    handleSocialClick: PropTypes.func
};

RetweetPanel.defaultProps = {
    selectedSocials: [],
    mainTweeter: 0,
    context: '',
    reselectMain: () => {},
    socialClickHandler: () => {},
    handleSocialClick: () => {}
};

export default RetweetPanel;
